import { showInformer } from '@ui/status-informer';
import { notification } from 'antd';

export async function responseErrorInterceptorNotification<Return = void>(
  props: IResponseErrorInterceptorNotificationProps<Return>,
  // @ts-ignore
): Promise<Return> {
  try {
    return await props.handler();
  } catch (err: Response | Error | any) {
    console.error(err);

    const isResponse = err instanceof Response;
    const body = isResponse ? await err.json() : err;

    notification.error({
      message: isResponse ? 'Ошибка' : err.message || err.error || 'Произошла ошибка',
      description: isResponse ? body.message || body.error : undefined,
    });

    props.catchHandler?.(err, isResponse, body);
    throw err;
  }
}

export interface IResponseErrorInterceptorNotificationProps<Return = void> {
  handler: () => Promise<Return>;
  catchHandler?: (err: Response | Error | any, isResponse: boolean, body: any) => any;
}
